import { useTranslation } from 'react-i18next';
import SelectFilter from 'common/TableFilters/SelectFilter';
import { FilterOption } from 'common/TableFilters/types';
import { AssetEventCategory } from '@electricjs/core_entity-client';
import { CategoryMap } from '@/components/Assets/AssetEventsHistory/types';
import { Flex, spaces } from '@electricjs/arc';
import SelectChip from 'common/TableFilters/SelectChip';

export const categoryOptions: FilterOption<AssetEventCategory>[] =
  Object.entries(CategoryMap).map(([key, value]) => ({
    id: key,
    value: key as AssetEventCategory,
    text: value,
  }));

export const CategoryFilter = ({
  categories,
  handleAddCategory,
}: {
  categories: AssetEventCategory[];
  handleAddCategory: (categories: AssetEventCategory[]) => void;
}) => {
  const { t } = useTranslation('assets');
  const handleAddFilter = (category: AssetEventCategory) => {
    handleAddCategory([...categories, category]);
  };

  const removeFilter = (category: AssetEventCategory) => {
    handleAddCategory(categories.filter(s => s !== category));
  };

  const translatedCategoryOptions = categoryOptions.map(option => {
    const formattedCategory = CategoryMap[option.value];
    const translatedCategory = t(
      `eventsHistory.categories.${formattedCategory.toLowerCase()}`
    );
    return {
      ...option,
      text: translatedCategory,
    };
  });

  return (
    <Flex alignItems="center" gap={spaces.space_m_rem}>
      <SelectFilter
        filterName={t('eventsHistory.filters.category')}
        options={translatedCategoryOptions}
        selectedValues={categories}
        handleAddFilter={value => {
          if (categories.includes(value)) {
            removeFilter(value);
          } else {
            handleAddFilter(value);
          }
        }}
      />
      <SelectChip
        selectedValues={categories}
        options={translatedCategoryOptions}
        handleRemoveFilter={removeFilter}
      />
    </Flex>
  );
};
